<template>
  <div class="helpList">
    <div
      class="publicTitle display-flex justify-content-space-between align-items-center"
    >
      <h5 class="h5">
        <img src="../../assets/img/titleLine.png" alt /> 常见问题
      </h5>
    </div>
    <ul>
      <li
        v-for="item in list"
        :key="item.id"
        @click="handleToDetail(item.content)"
      >
        <p>{{ item.title }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import { postData, showLoading } from "../../assets/api/api.js";
export default {
  name: "helpList",

  data() {
    return {
      list: [],
    };
  },
  created() {
    this.loadData();
  },
  mounted() {},
  computed: {},
  methods: {
    handleToDetail(content) {
      this.$router.push({
        name: "HelpDetail",
        params: { content: content },
      });
    },
    loadData() {
      showLoading();
      postData("system_article/list", {}).then((res) => {
        this.list = res.data.content;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.helpList {
  ul {
    min-height: 450px;
    margin-top: 30px;
    padding-left: 30px;
    padding-right: 10px;
    p {
      cursor: pointer;
      margin-bottom: 15px;
    }
  }
}
</style>
